// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"84225fdc","474":"3b13d523","555":"55f27b90","615":"f49cafd3","677":"f42ebeff","818":"ba0ee96e","852":"5494c38a","981":"a06c49e1"}[chunkId] + ".chunk.js";
};